module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-two.db4be375.png";